export default __webpack_public_path__ + "static/media/empty_box.4cd7aa4f.svg";